<app-question-template [form]="form" [question]="question">
	@if (isV2()) {
		<ion-input
			(ionInput)="onChange($event)"
			type="email"
			fill="outline"
			labelPlacement="stacked"
			label="{{ 'CHECKLISTS__QUESTIONS__EMAIL__PLACEHOLDER' | transloco }}"
			#questionEmail
			[value]="model.value"
			required
		></ion-input>
	} @else {
		<ion-item>
			<ion-input
				label="{{ 'CHECKLISTS__QUESTIONS__EMAIL__PLACEHOLDER' | transloco }}"
				labelPlacement="stacked"
				#questionEmail
				(ionInput)="onChange($event)"
				type="email"
				[value]="model.value"
				required
			></ion-input>
		</ion-item>
	}
</app-question-template>
